import { useAtom } from '@reatom/npm-react'
import { AnimatePresence, LayoutGroup, motion } from 'motion/react'
import React from 'react'
import styled, { css } from 'styled-components'

import { mediaMaxMobile } from '../theme'

import { snackbarsStateAtom } from './atoms'
import { Snackbar } from './snackbar'

import type { SnackbarState } from './atoms'
import type { ChildrenProps } from '@root/shared/react'

const layoutTransition = {
  layout: { duration: 0.2, ease: 'easeInOut' },
} as const

type SnackbarContextProps = {} & ChildrenProps

export const SnackbarProvider: React.FC<SnackbarContextProps> = ({
  children,
}) => {
  const [entries] = useAtom(snackbarsStateAtom)

  const renderSnackbar = (entry: SnackbarState) => {
    if (entry.options.element) {
      return React.cloneElement(entry.options.element, {
        onClose: entry.options.onClose,
      })
    }

    return (
      <Snackbar
        intent={entry.options.intent ?? 'info'}
        description={entry.options.description}
        onClose={entry.options.onClose}
      >
        {entry.options.text}
      </Snackbar>
    )
  }

  return (
    <Root layout transition={layoutTransition}>
      <LayoutGroup>
        <AnimatePresence>
          {entries.map((it) => (
            <SnackbarItem
              key={it.id}
              layout
              transition={layoutTransition}
              initial={{ scale: 0, opacity: 0.3 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.7, opacity: 0 }}
            >
              {renderSnackbar(it)}
            </SnackbarItem>
          ))}
        </AnimatePresence>
        <ChildrenSlot layout transition={layoutTransition}>
          {children}
        </ChildrenSlot>
      </LayoutGroup>
    </Root>
  )
}

const Root = styled(motion.div)`
  position: fixed;
  display: grid;

  bottom: 0;
  right: 0;
  grid-gap: 4px;
  width: 360px;

  padding: 10px 10px 25px;

  pointer-events: none;
  background: transparent;

  ${mediaMaxMobile(css`
    bottom: 0;
    right: 0;
    left: 0;
    padding-inline: 12px;
    padding-bottom: var(--safe-bottom);
    width: auto;
    grid-gap: 8px;
  `)}
`

const SnackbarItem = styled(motion.div)``

const ChildrenSlot = styled(motion.div)``
